import api from './api';

export const getNotes = (params) =>
  api.get('/api/v1/notes', { params }).then((r) => r.data.data);

export const getNote = (id) =>
  api.get(`/api/v1/notes/${id}`).then((r) => r.data.data);

export const createNote = (data) =>
  api.post('/api/v1/notes', data).then((r) => r.data.data);

export const updateNote = (id, data) =>
  api.put(`/api/v1/notes/${id}`, data).then((r) => r.data.data);

export const signNote = (id) =>
  api.post(`/api/v1/notes/${id}/sign`).then((r) => r.data.data);

export const deleteNote = (id) =>
  api.delete(`/api/v1/notes/${id}`).then((r) => r.data);
